
import { PrincipleItemModelDto } from '../configuration/cycle-partner-configuration/PrincipleItemModelDto';
import { CycleProcess } from 'src/app/shared/interfaces/cycle.interface';


export class PerformanceCycle {
    id?: number;
    name: string;
    term: number;
    year: number;
    defaultCycle: boolean;
    processes?: Array<CycleProcess>;
    users?: Array<string>;
    hasConfigUrls: boolean;
    hasConfigPrinciples: boolean;
    hasConfigLeadership: boolean;
    fundamentalPrinciples: PrincipleItemModelDto[];
    leadershipPrinciples: PrincipleItemModelDto[];
    isCyclePartner: boolean;
    welcomePtBr?: string;
    welcomeEnUs?: string;
    welcomeEsEs?: string;
    urlVideoPtBr?: string;
    urlVideoEnUs?: string;
    urlVideoEsEs?: string;

    logoUrl?: string;

    constructor(cycleId: number, name: string, year: number, term: number, defaultCycle: boolean) {
        this.name = name;
        this.term = term;
        this.year = year;
        this.id = cycleId;
        this.defaultCycle = defaultCycle;
    }
}
